import React from 'react';
import styles from './TrackingTabs.module.css';

const TrackingTabs = ({ activeTab, onTabChange }) => {
  return (
    <div className={styles.container}>
      <button
        className={`${styles.tabButton} ${activeTab === 'fastag' ? styles.active : ''}`}
        onClick={() => onTabChange('fastag')}
      >
        FASTag
      </button>
      <button
        className={`${styles.tabButton} ${activeTab === 'sim' ? styles.active : ''}`}
        onClick={() => onTabChange('sim')}
      >
        SIM
      </button>
    </div>
  );
};

export default TrackingTabs;
